export default {
  fields: {
    demo: {
      label: 'Criar Demo',
    },
    ai: {
      label: 'Otimizado por IA',
    },
    restaurant_type: {
      label: 'Selecionar tipo de restaurante',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Pizza com Entrega 🍕🚗',
        PizzaNeapolitan: 'Pizza Napolitana 🍕',
        Italian: 'Italiano 🇮🇹',
        Burger: 'Hambúrguer 🍔',
        Turkish: 'Turco 🇹🇷',
        Mexican: 'Mexicano 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japonês 🇯🇵',
        Vietnamese: 'Vietnamita 🇻🇳',
        Thai: 'Tailandês 🇹🇭',
        Asian: 'Asiático 🍜',
        Indian: 'Indiano 🥘',
        Bowls: 'Bowls 🥣',
        Vegan: 'Vegan 🥑',
        Greek: 'Grego 🏛️',
        Cafe: 'Café ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Oriental / Médio Oriente 🧆',
        Spanish: 'Espanhol / Tapas 🇪🇸',
        Persian: 'Persa 🫖',
      },
    },
    plugins: {
      reservations: 'Reservas',
      reservations_plan_hint:
        'As reservas requerem um Plano Parceiro. Ser-lhe-á pedido para o ativar para {{name}} ao criar o website.',
      catering: 'Catering',
      events: 'Eventos',
    },
    quarter: {
      label: 'Bairro',
      address_placeholder: 'Introduzir morada',
      quarter_placeholder: 'Introduzir bairro',
    },
    delivery_areas: {
      label: 'Quais as zonas da cidade que serve?',
      city_placeholder: 'Introduzir cidade',
      district_placeholder: 'Bairro 1, Bairro 2, Bairro 3',
    },
    best_dishes: {
      label: 'Quais os seus 3 pratos principais?',
      placeholder: 'Introduzir pratos (Hambúrguer de frango, Hambúrguer de queijo, etc.)',
    },
    dietary_attributes: {
      label: 'Tem opções para quem quer comer:',
      placeholder: 'Selecionar atributos alimentares',
      types: {
        vegetarian: 'Vegetariano',
        vegan: 'Vegan',
        halal: 'Halal',
        gluten_free: 'Sem Glúten',
        dairy_free: 'Sem Lactose',
        spicy: 'Picante',
      },
    },
    family_owned: {
      label: 'Negócio familiar?',
      yes: 'Sim',
      no: 'Não',
    },
    business_founding_year: {
      label: 'Em que ano foi fundado o restaurante?',
    },
    business_owners: {
      label: 'Proprietários do negócio',
      placeholder: 'Introduzir proprietário',
    },
    notes: {
      label: 'Adicionar notas adicionais (opcional)',
      placeholder: 'Exemplo: restaurante orientado para a comunidade, iniciativas, casal proprietário...',
    },
    about_us: {
      title: 'Sobre Nós (Pré-visualização)',
    },
  },
  sections: {
    plugins: 'Plugins',
    company_info: 'Gerar Informação da Empresa',
  },
  buttons: {
    find_district: 'Encontrar bairro',
    generate: 'Gerar',
    products: 'Produtos',
    add: 'Adicionar',
  },
};
